'use strict';
import * as scoreHierarchy from '../scoreHierarchy'
import sectionLabels from "../sectionLabels"
import moment from 'moment'
import _ from 'lodash'
import presignedExport from '../../../services/auth/presignedExport';

angular.module('clientDashboardApp').controller("ScoreStoreComparisonCtrl",
  ($scope, $location, $state,
   $q,
   locationService, scoreResultsService,
   sharedScoringReportFilters
   ) => {

    $scope.topLevelPaths = scoreHierarchy.withDescendants('total', 2)

    $scope.sectionLabels = sectionLabels

    $scope.searchConfig = sharedScoringReportFilters.restoreFilters()

    $scope.searchConfig.showGroups = $state.params.showGroups;

    $scope.expandedState = {}

    $scope.export = () => {
      const { groupId, start, end, showGroups } = $scope.searchConfig
      const type = showGroups ? 'groups' : 'locations'
      presignedExport.downloadExport(`/v5/scores/${type}/averagesExport`, {
        groupId, start: start.toDate(), end: end.toDate()
      })
    }

    $scope.$watch(() => ($state.params.showGroups), (nv,ov) => {
      if(nv !== ov){
        $scope.searchConfig.showGroups = nv
        if ($scope.pagination.sortField === "location"){
          $scope.pagination.sortField = "group"
        }
        search()
      }
    },1)

    const search = () => {
      $scope.loadingResults = true

      const { start, end, groupId, showGroups } = $scope.searchConfig
      const startDate = start.toDate()
      const endDate = end.toDate()

      if(!showGroups){
        return searchForLocations(startDate, endDate, groupId)
      } else {
        return searchForGroups(startDate, endDate, groupId, $scope.pagination.sortField)
      }
    }

    const addDisplayFields = scoreChange => ({...scoreChange,
      outOf100: scoreChange.current ? Math.round(scoreChange.current * 100) : undefined,
      metric: {
        value: scoreChange.current,
        delta: scoreChange.delta
      }
    })

    function searchForLocations(startDate, endDate, groupId) {
      const checkPagination = !$scope.pagination.pendingRecomputation ? $q.resolve(undefined) :
        scoreResultsService.getSortedLocationIds({
          start: startDate,
          end: endDate,
          groupId,
          sortField: $scope.pagination.sortField
        })
          .then(({ sorted, count }) => {
            $scope.pagination.pendingRecomputation = false
            $scope.pagination.total = count
            $scope.pagination.totalPages = (Math.ceil(count / $scope.pagination.limit) - 1)

            $scope.pagination.sorted = sorted
          })


      return checkPagination
        .then(() => {

          const thisPageIds = $scope.pagination.thisPage()

          return scoreResultsService.locationAverages({
            start: startDate,
            end: endDate,
            scorePaths: $scope.topLevelPaths,
            locationIds: thisPageIds
          })
        })

        .then(scores => {
          $scope.locations = scores.values.map(result => {
            return {
              locationId: result.locationId,
              byPath:
                result
                  .values
                  .reduce((sum, x) => ({...sum, [x.scorePath]: addDisplayFields(x) }), {}),
              address: result.locationAddress,
              name: result.locationName
            }
          })

          $scope.loadingResults = false
        })
    }

    function searchForGroups(startDate, endDate, groupId, sortField) {

      $scope.expandedState = {}

      if ($scope.groups) {
        $scope.groups.forEach(group => {
          if (group.isOpen) {
            $scope.expandedState[group.groupId] = true
          }
        })
      }

      return scoreResultsService.locationGroupAverages({
        start: startDate,
        end: endDate,
        scorePaths: $scope.topLevelPaths,
        groupId,
        sortField
      }).then( scores => {

        $scope.pagination.pendingRecomputation = false
        $scope.pagination.total = scores.count
        $scope.pagination.totalPages = (Math.ceil(scores.sorted.values.length / $scope.pagination.limit) - 1)
        $scope.pagination.sorted = scores.sorted.values

        const mapGroupResult = (result,isOpen) => {
          return {
            groupId: result.groupId,
            byPath:
              result
                .values
                .reduce((sum, x) => ({...sum, [x.scorePath]: addDisplayFields(x) }), {}),
            locationIds: result.locationIds,
            name: result.groupName,
            locationCount: result.locationCount,
            isOpen: scores.count === 1 || $scope.expandedState[result.groupId] || isOpen
          }
        }

        $scope.groups = scores.sorted.values.map(result => {
          return mapGroupResult(result, false)
        })


        $scope.allGroups = mapGroupResult(scores.allGroups.value, true)
        $scope.groups = sortGroups($scope.groups, $scope.pagination.sortField, $scope.pagination.sortOrder)

        const groupLocationPromises = []

        $scope.groups.forEach(group => {
          if (group.isOpen) {
            groupLocationPromises.push(loadLocationsForGroup(group))
          }
        })

        $q.all(groupLocationPromises).then(() => {
          $scope.loadingResults = false
        })

      })
    }

    function sortGroups(groups, sortField, sortOrder) {
      let sorted
      if (sortField === "group") {
        sorted = _.sortBy(groups, group => group.name.toLowerCase())
      } else { // score path...
        sorted = _.sortBy(groups, group => group.byPath[sortField].current)
      }

      return sortOrder === -1 ? sorted.reverse() : sorted
    }

    function loadLocationsForGroup(group) {
      const {start,end} = $scope.searchConfig
      const {sortOrder,sortField} = $scope.pagination
      const startDate = start.toDate(), endDate = end.toDate()

      let promises = {
        sortedLocationIds : scoreResultsService.getSortedLocationIds({
          start: startDate,
          end: endDate,
          groupId: group.groupId,
          locationIds : group.locationIds,
          sortField: sortField === 'group' ? 'location' : sortField
        }),
        locationAverages : scoreResultsService.locationAveragesForGroupId({
          start: startDate,
          end: endDate,
          scorePaths: $scope.topLevelPaths,
          groupId : group.groupId,
          locationIds : group.locationIds
        })
      }

      return $q.all(promises).then( ({sortedLocationIds,locationAverages}) => {
        let sortedWithDirection = sortOrder === 1 ? sortedLocationIds.sorted : sortedLocationIds.sorted.slice().reverse()
        group.locations = sortedWithDirection.map( locationId => {
          const result = locationAverages.values.find(item => (item.locationId === locationId))
          return {
            locationId: result.locationId,
            byPath:
              result
                .values
                .reduce((sum, x) => ({...sum, [x.scorePath]: addDisplayFields(x) }), {}),
            address: result.locationAddress,
            name: result.locationName
          }
        })

        group.loading = false
        group.isOpen = true
      })
    }

    $scope.toggleGroupLocations = (group) => {
      group.loading = true

      if(group.groupId === 'All' || (group.locations && group.locations.length)) {
        group.isOpen = !group.isOpen
        group.loading = false
        return
      }

      loadLocationsForGroup(group)
    }

    $scope.locations = []

    const defaultSorts = {
      "group": 1,
      "default": -1
    }
    $scope.sortBy = (field) => {
      if ($scope.pagination.sortField === field) {
        $scope.pagination.sortOrder = $scope.pagination.sortOrder * -1
      } else {
        $scope.pagination.sortField = field;
        $scope.pagination.sortOrder = defaultSorts[field] || defaultSorts.default
        $scope.pagination.pendingRecomputation = true;
      }

      if ($scope.searchConfig.showGroups) {
        $scope.groups = sortGroups($scope.groups, $scope.pagination.sortField, $scope.pagination.sortOrder)
      } else {
        search()
      }
    }

    $scope.pagination = {
      pendingRecomputation: true,
      total: 0,
      limit: 20,
      currentPage: 0,
      //getPaginationModel yells about currentPage being out of bounds if this is less than 1
      totalPages: 1,
      sortField: $scope.searchConfig.showGroups ? "group" : "location",
      sortOrder: 1,
      sorted: [],
      nthPage: (page) => {
        $scope.pagination.currentPage = page - 1;
        search()
      },
      thisPage: () => {
        const {
          limit, currentPage, sortOrder, sorted
        } = $scope.pagination
        const withDirection = sortOrder === 1 ? sorted : sorted.slice().reverse()
        const startIdx = currentPage * limit
        const endIdx = startIdx + limit
        return withDirection.slice(startIdx, endIdx)
      }
    }

    $scope.setDateRange = ({start, end}) => {
      Object.assign($scope.searchConfig, {start, end})
    }



    search()
      .then(x => {
        // use $watchCollection to avoid some of the shittiness of normal $watch
        // - normal $watch is fired once initially
        // $watchCollection also makes sense b/c it does a shallow equals on the search config properties
        $scope.$watchCollection(sc => Object.values(sc.searchConfig), (a, b) => {
          if (!_.isEqual(a, b)) {
            sharedScoringReportFilters.persistFilters($scope.searchConfig);

            if ($scope.pagination.sortField !== "location" || a.groupId !== b.groupId) {
              // optimize to not recompute if is sorted by locations
              $scope.pagination.pendingRecomputation = true;
            }

            search()
          }
        })

        $scope.$watch(() => (locationService.getSelectedGroupId()), (newVal, oldVal) => {
          $scope.pagination.pendingRecomputation = true
          $scope.searchConfig.groupId = newVal
        })


    })

  })
